module.exports = __webpack_public_path__ + "static/media/mac.cd0682a7.png";